module.exports = __webpack_public_path__ + "static/media/7_Peace of mind_RU.3fdd81af.txt";